const initialState = () => ({
  workspace: {},
  admins: []
})

export default api => ({
  state: initialState,

  getters: {
    workspace: state => state.workspace,
    workspaceAdmins: state => state.admins,
    isMeWorkspaceAdmin: (state, getters) => state.admins.indexOf(getters.profileMe.id) !== -1
  },

  mutations: {
    updateWorkspace: (state, workspace) => {
      state.workspace = workspace
    },

    clearWorkspace: state => {
      state.workspace = {}
    },

    fetchCompanyAdmins: (state, admins) => {
      state.admins = admins
    },

    addCompanyAdmin: (state, profileId) => {
      state.admins = [...state.admins, profileId]
    },

    deleteCompanyAdmin: (state, profileId) => {
      state.admins = state.admins.filter(id => id !== profileId)
    },

    resetWorkspaces: state => {
      const payload = initialState()
      Object.keys(payload).forEach(key => {
        state[key] = payload[key]
      })
    }
  },

  actions: {
    companySignUp: async ({ commit }, data) => {
      await api.companySignUp(data)
    },

    companySignUpVerify: async ({ commit }, key) => {
      const result = await api.companySignUpVerify({ key })
      commit('updateWorkspace', result.details)
      return result
    },

    companySignUpCheckName: async ({ commit }, name) => {
      await api.companySignUpCheckName({ name })
    },

    forgotCompanyUrl: async ({ commit }, email) => {
      await api.forgotWorkspace(email)
    },

    teamInvitationVerify: async ({ commit }, key) => {
      const result = await api.teamInvitationVerify({ key })
      commit('updateWorkspace', result.details.team.company)
    },

    fetchCompany: async ({ commit }, companySlug) => {
      const result = await api.fetchCompany(companySlug)
      commit('updateWorkspace', result)
    },

    previewUserInvitation: async ({ commit }, teamName) => {
      const slug = api.getWorkspaceSlug()
      return await api.previewUserInvitation(slug, teamName)
    },

    inviteUsers: async ({ commit }, data) => {
      const slug = api.getWorkspaceSlug()
      await api.inviteUsers(slug, data)
    },

    getInvitationLink: async ({ commit }, teamId) => {
      const slug = api.getWorkspaceSlug()
      return await api.getInvitationLink(slug, teamId)
    },

    validateInvitationLink: async ({ commit }, { companySlug, key }) => {
      return await api.validateInvitationLink(companySlug, key)
    },

    inviteUserByInvitationLink: async ({ commit }, { companySlug, key, email }) => {
      await api.inviteUserByInvitationLink(companySlug, key, email)
    },

    getWorkspaceSlug: ({ commit }) => {
      return api.getWorkspaceSlug()
    },

    clearWorkspace: ({ commit }) => {
      commit('clearWorkspace')
      api.clearWorkspaceSlug()
    },

    fetchCompanyAdmins: async ({ commit }) => {
      const slug = api.getWorkspaceSlug()
      const { admins } = await api.fetchCompanyAdmins(slug)
      commit('fetchCompanyAdmins', admins)
    },

    addCompanyAdmin: async ({ commit }, profileId) => {
      const slug = api.getWorkspaceSlug()
      await api.addCompanyAdmin(slug, profileId)
      commit('addCompanyAdmin', profileId)
    },

    deleteCompanyAdmin: async ({ commit }, profileId) => {
      const slug = api.getWorkspaceSlug()
      await api.deleteCompanyAdmin(slug, profileId)
      commit('deleteCompanyAdmin', profileId)
    },

    clear: ({ commit }) => {
      commit('resetWorkspaces')
    }
  }
})
